export const COUNTRY_LIST = [
  {
    en: 'Albania',
    zh: '阿尔巴尼亚',
    code: 'AL'
  },
  {
    en: 'Algeria',
    zh: '阿尔及利亚',
    code: 'DZ'
  },
  {
    en: 'Andorra',
    zh: '安道尔',
    code: 'AD'
  },
  {
    en: 'Angola',
    zh: '安哥拉',
    code: 'AO'
  },
  {
    en: 'Argentina',
    zh: '阿根廷',
    code: 'AR'
  },
  {
    en: 'Armenia',
    zh: '亚美尼亚',
    code: 'AM'
  },
  {
    en: 'Australia',
    zh: '澳大利亚',
    code: 'AU'
  },
  {
    en: 'Austria',
    zh: '奥地利',
    code: 'AT'
  },
  {
    en: 'Azerbaijan',
    zh: '阿塞拜疆',
    code: 'AZ'
  },
  {
    en: 'Bahamas',
    zh: '巴哈马',
    code: 'BS'
  },
  {
    en: 'Bahrain',
    zh: '巴林',
    code: 'BH'
  },
  {
    en: 'Bangladesh',
    zh: '孟加拉国',
    code: 'BD'
  },
  {
    en: 'Belarus',
    zh: '白俄罗斯',
    code: 'BY'
  },
  {
    en: 'Belgium',
    zh: '比利时',
    code: 'BE'
  },
  {
    en: 'Belize',
    zh: '伯利兹',
    code: 'BZ'
  },
  {
    en: 'Benin',
    zh: '贝宁',
    code: 'BJ'
  },
  {
    en: 'Bhutan',
    zh: '不丹',
    code: 'BT'
  },
  {
    en: 'Bolivia',
    zh: '玻利维亚',
    code: 'BO'
  },
  {
    en: 'Bosnia and Herzegovina',
    zh: '波黑',
    code: 'BA'
  },
  {
    en: 'Botswana',
    zh: '博茨瓦纳',
    code: 'BW'
  },
  {
    en: 'Brazil',
    zh: '巴西',
    code: 'BR'
  },
  {
    en: 'Brunei',
    zh: '文莱',
    code: 'BN'
  },
  {
    en: 'Bulgaria',
    zh: '保加利亚',
    code: 'BG'
  },
  {
    en: 'Cambodia',
    zh: '柬埔寨',
    code: 'KH'
  },
  {
    en: 'Cameroon',
    zh: '喀麦隆',
    code: 'CM'
  },
  {
    en: 'Canada',
    zh: '加拿大',
    code: 'CA'
  },
  {
    en: 'Chile',
    zh: '智利',
    code: 'CL'
  },
  {
    en: 'China',
    zh: '中国',
    code: 'CN'
  },
  {
    en: 'Colombia',
    zh: '哥伦比亚',
    code: 'CO'
  },
  {
    en: 'Costa Rica',
    zh: '哥斯达黎加',
    code: 'CR'
  },
  {
    en: 'Croatia',
    zh: '克罗地亚',
    code: 'HR'
  },
  {
    en: 'Cuba',
    zh: '古巴',
    code: 'CU'
  },
  {
    en: 'Cyprus',
    zh: '塞浦路斯',
    code: 'CY'
  },
  {
    en: 'Czech Republic',
    zh: '捷克',
    code: 'CZ'
  },
  {
    en: 'Denmark',
    zh: '丹麦',
    code: 'DK'
  },
  {
    en: 'Egypt',
    zh: '埃及',
    code: 'EG'
  },
  {
    en: 'Finland',
    zh: '芬兰',
    code: 'FI'
  },
  {
    en: 'France',
    zh: '法国',
    code: 'FR'
  },
  {
    en: 'Germany',
    zh: '德国',
    code: 'DE'
  },
  {
    en: 'Greece',
    zh: '希腊',
    code: 'GR'
  },
  {
    en: 'India',
    zh: '印度',
    code: 'IN'
  },
  {
    en: 'Indonesia',
    zh: '印度尼西亚',
    code: 'ID'
  },
  {
    en: 'Ireland',
    zh: '爱尔兰',
    code: 'IE'
  },
  {
    en: 'Israel',
    zh: '以色列',
    code: 'IL'
  },
  {
    en: 'Italy',
    zh: '意大利',
    code: 'IT'
  },
  {
    en: 'Japan',
    zh: '日本',
    code: 'JP'
  },
  {
    en: 'Kazakhstan',
    zh: '哈萨克斯坦',
    code: 'KZ'
  },
  {
    en: 'Kenya',
    zh: '肯尼亚',
    code: 'KE'
  },
  {
    en: 'Malaysia',
    zh: '马来西亚',
    code: 'MY'
  },
  {
    en: 'Mexico',
    zh: '墨西哥',
    code: 'MX'
  },
  {
    en: 'Netherlands',
    zh: '荷兰',
    code: 'NL'
  },
  {
    en: 'New Zealand',
    zh: '新西兰',
    code: 'NZ'
  },
  {
    en: 'Nigeria',
    zh: '尼日利亚',
    code: 'NG'
  },
  {
    en: 'Norway',
    zh: '挪威',
    code: 'NO'
  },
  {
    en: 'Pakistan',
    zh: '巴基斯坦',
    code: 'PK'
  },
  {
    en: 'Philippines',
    zh: '菲律宾',
    code: 'PH'
  },
  {
    en: 'Poland',
    zh: '波兰',
    code: 'PL'
  },
  {
    en: 'Portugal',
    zh: '葡萄牙',
    code: 'PT'
  },
  {
    en: 'Russia',
    zh: '俄罗斯',
    code: 'RU'
  },
  {
    en: 'Saudi Arabia',
    zh: '沙特阿拉伯',
    code: 'SA'
  },
  {
    en: 'Singapore',
    zh: '新加坡',
    code: 'SG'
  },
  {
    en: 'South Africa',
    zh: '南非',
    code: 'ZA'
  },
  {
    en: 'South Korea',
    zh: '韩国',
    code: 'KR'
  },
  {
    en: 'Spain',
    zh: '西班牙',
    code: 'ES'
  },
  {
    en: 'Sweden',
    zh: '瑞典',
    code: 'SE'
  },
  {
    en: 'Switzerland',
    zh: '瑞士',
    code: 'CH'
  },
  {
    en: 'Thailand',
    zh: '泰国',
    code: 'TH'
  },
  {
    en: 'Turkey',
    zh: '土耳其',
    code: 'TR'
  },
  {
    en: 'Ukraine',
    zh: '乌克兰',
    code: 'UA'
  },
  {
    en: 'United Arab Emirates',
    zh: '阿联酋',
    code: 'AE'
  },
  {
    en: 'United Kingdom',
    zh: '英国',
    code: 'GB'
  },
  {
    en: 'United States',
    zh: '美国',
    code: 'US'
  },
  {
    en: 'Vietnam',
    zh: '越南',
    code: 'VN'
  }
];
